import { type SupportBlocking, type SupportCategory, type SupportContext, type SupportStatus } from '@onr/schema'

import { type OnrApiMutationOptions, useOnrApi } from './mutation/useOnrApi.ts'

export interface CreateSupportRequestVariables {
  category: SupportCategory
  blocking: SupportBlocking
  text: string
  context: Pick<SupportContext, 'page' | 'object' | 'system'>
}

export interface SupportAgentSendVariables {
  number: number
  mode: 'reply' | 'note'
  text: string
  afterStatus: SupportStatus
}

export const useCreateSupportRequest = (
  options?: OnrApiMutationOptions<{ number: number }, CreateSupportRequestVariables>
) => useOnrApi<{ number: number }, CreateSupportRequestVariables>({ type: 'supportRequestCreate', ...options })

export const useReplySupportRequest = (options?: OnrApiMutationOptions<void, { number: number; text: string }>) =>
  useOnrApi<void, { number: number; text: string }>({ type: 'supportRequestReply', ...options })

export const useSettleSupportRequest = (options?: OnrApiMutationOptions<void, { number: number }>) =>
  useOnrApi<void, { number: number }>({ type: 'supportRequestSettle', ...options })

export const useSupportAgentSend = (options?: OnrApiMutationOptions<void, SupportAgentSendVariables>) =>
  useOnrApi<void, SupportAgentSendVariables>({ type: 'supportAgentSend', ...options })

export const useSupportAgentRename = (options?: OnrApiMutationOptions<void, { number: number; title: string }>) =>
  useOnrApi<void, { number: number; title: string }>({ type: 'supportAgentRename', ...options })

export const useSupportAgentSetStatus = (
  options?: OnrApiMutationOptions<void, { number: number; status: SupportStatus }>
) => useOnrApi<void, { number: number; status: SupportStatus }>({ type: 'supportAgentSetStatus', ...options })

export const useSupportAgentAssign = (
  options?: OnrApiMutationOptions<void, { number: number; piloteUserId: number | null }>
) => useOnrApi<void, { number: number; piloteUserId: number | null }>({ type: 'supportAgentAssign', ...options })
